var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button-long",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('button-loader'):_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }